<i18n src="../../locales/lang.json"></i18n>

<template>
  <div>
    <modal-empty showheader="false" ref="thisModal" size="modal-lg p-0">
      <form class="wizard-form steps-basic" action="#" data-fouc id="nuxForm">
        <h6>{{ $t('NUX_intro_title_collaborate') }}</h6>
        <fieldset>
          <div class="row">
            <div class="col-md-6 py-md-3">
              <img class="mx-auto d-block" src="/Images/nux-collaborate.png" width="75%" />
            </div>

            <div class="col-md-6 pl-md-5 pt-md-3">
              <span class="custom-medium-text">
                {{ $store.translate('NUX_intro_content_collaborate') }}
              </span>
            </div>
          </div>
        </fieldset>
        <h6>{{ $t('NUX_intro_title_dynamic_task') }}</h6>
        <fieldset>
          <div class="row">
            <div class="col-md-6 py-md-3">
              <img class="mx-auto d-block" src="/Images/nux-task-management.png" width="75%" width="75%" />
            </div>

            <div class="col-md-6 pl-md-5 pt-md-3">
              <span class="custom-medium-text">
                {{ $t('NUX_intro_content_dynamic_task') }}
                
              </span>
            </div>
          </div>
        </fieldset>
        <h6>{{ $t('NUX_intro_title_rich_filtering') }}</h6>
        <fieldset>
          <div class="row">
            <div class="col-md-6 py-md-5">
              <img class="mx-auto d-block" src="/Images/nux-filter.png" width="75%" />
            </div>

            <div class="col-md-6 pb-2 pb-md-3 px-5 px-md-5 pt-md-5">
              <span class="custom-medium-text">
                {{ $t('NUX_intro_content_rich_filtering') }}
              </span>
            </div>
          </div>

        </fieldset>
      </form>
    </modal-empty>
    <ticker ref="ticker"></ticker>
  </div>

</template>

<script>

  import ModalEmpty from "../modals/modal-empty.vue";
  import ticker from '../common/common-ticker.vue'


  export default {
    name: "nux-flow",
    components: {
      ModalEmpty,
      ticker
    },
    props: {
      
      state: {
        type: String,
        default: "closed"
      },
      startlink: {
        type: String,
        default: null
      },
      
    },
    data() {
      return {
        
      };
    },
    methods: {
     
      
      open() {
        this.$refs.thisModal.open();
      },
      close() {
        if (this.startlink != null) {
          this.$refs.ticker.start("nuxForm");
          location.href = this.startlink;
        }
        else
          this.$refs.thisModal.close();
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      initWizard() {
        $('.steps-basic').steps({
          headerTag: 'h6',
          bodyTag: 'fieldset',
          transitionEffect: 'fade',
          titleTemplate: '<span class="number">#index#</span> #title#',
          labels: {
            previous: '<i class="icon-arrow-left13 mr-2" /> Previous',
            next: 'Next <i class="icon-arrow-right14 ml-2" />',
            finish: 'Lets start! <i class="icon-arrow-right14 ml-2" />'
          },
          onFinished: this.close
        });
      },
      openWithUrl(url) {
        this.startlink = url;
        this.open();
      }
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted() {
      if (this.state == "open") {
        this.open();
      }
      this.initWizard();
      this.$root.$on('display_nux_intro', this.openWithUrl);
    },
    created() {
      
    },
  };

</script>

<style>
  .steps {
    background-color: #81DB00 !important;
  }
  .wizard > .steps > ul > li.current .number {
    color: #528900;
    border-color: #528900;
  }
  .wizard > .steps > ul > li a {
    color: white;
  }
  .wizard > .steps > ul > li.done a, .wizard > .steps > ul > li.done a:focus, .wizard > .steps > ul > li.done a:hover {
    color: #528900;
  }

  .wizard > .steps > ul > li.done .number {
    color: white;
    border-color: #528900;
  }
  .wizard > .steps > ul > li.done .number {
    background-color: #528900;
  }

  .wizard > .steps > ul > li::after, .wizard > .steps > ul > li::before {
    background-color: #528900;
  }

  .wizard > .steps > ul > li.current::after {
    background-color: #528900;
  }

  .modal-content {
    border-color: #919191;
  }

  @media (max-width: 768px) {
    #nuxForm-t-2 {
        color:orange !important;
    }
    .wizard > .steps > ul > li a {
      padding-top: 35px;
      margin-top: 20px
    }
    .wizard > .steps > ul > li::after,.wizard > .steps > ul > li::before {
      height: 0px;
    }
    .wizard > .steps > ul > li{
        display:block;
        margin-left:20px;
    }
  }

 
</style>



// WEBPACK FOOTER //
// src/components/nux/nux-flow.vue